import { useState, useRef } from "react";
import Typography from "../Typography/Typography";
import { Quote } from "../../Icons/Quote";

const testimonials = [
    {
        text: "Athena mi ha letteralmente salvato la vita! Prima perdevo ore a organizzare le fonti e strutturare la tesi, ora è tutto automatizzato e super intuitivo. Consigliatissimo!",
        author: "Giulia Ferri",
        university: "Università di Padova",
    },
    {
        text: "Pensavo che scrivere la tesi sarebbe stato un incubo, ma con Athena ho tutto sotto controllo. La roadmap mi ha aiutato a rispettare le scadenze e a evitare il panico dell’ultimo minuto!",
        author: "Marco Rinaldi",
        university: "Università degli Studi di Milano",
    },
    {
        text: "Non sapevo nemmeno da dove iniziare con la mia tesi, poi ho provato Athena e tutto è diventato più chiaro. L’indice automatico e la gestione delle fonti sono una svolta totale!",
        author: "Elena Russo",
        university: "Università di Torino",
    },
];

export default function Testimonials(isPage) {
    const [activeIndex, setActiveIndex] = useState(0);
    const touchStartX = useRef(0);
    const touchEndX = useRef(0);
    const mouseStartX = useRef(0);
    const mouseEndX = useRef(0);

    const handleSwipe = (startX, endX) => {
        if (startX - endX > 50) {
            // Swipe a sinistra → Avanza
            setActiveIndex((prev) => (prev + 1) % testimonials.length);
        } else if (startX - endX < -50) {
            // Swipe a destra → Torna indietro
            setActiveIndex((prev) => (prev - 1 + testimonials.length) % testimonials.length);
        }
    };

    // Mobile
    const handleTouchStart = (e) => {
        touchStartX.current = e.touches[0].clientX;
    };

    const handleTouchEnd = (e) => {
        touchEndX.current = e.changedTouches[0].clientX;
        handleSwipe(touchStartX.current, touchEndX.current);
    };

    // PC (mouse drag)
    const handleMouseDown = (e) => {
        mouseStartX.current = e.clientX;
    };

    const handleMouseUp = (e) => {
        mouseEndX.current = e.clientX;
        handleSwipe(mouseStartX.current, mouseEndX.current);
    };

    return (
        <div className="w-full">
            {/* Layout per schermi grandi */}
            <div className="hidden lg:flex gap-6">
                {testimonials.map((item, index) => (
                    <div
                        key={index}
                        className={`flex flex-col p-6 gap-6 rounded-[12px] ${index !== 1 ? " bg-gray-50 border-2 border-gray-100" : ""} ${isPage ? "bg-white border-2 border-gray-100" : ""}`}
                    >
                        <Quote className="fill-gray-600 w-6 h-6" />
                        <div className="flex flex-col gap-3">
                            <Typography size="20" weight="md">{item.text}</Typography>
                            <Typography size="12" desktopSize="16" weight="rg">
                                {item.author}<br />
                                <Typography size="12" desktopSize="16" weight="rg" color="gray-600">@ {item.university}</Typography>
                            </Typography>
                        </div>
                    </div>
                ))}
            </div>

            {/* Layout per schermi piccoli con swipe e drag */}
            <div
                className="lg:hidden relative w-full overflow-hidden"
                onTouchStart={handleTouchStart}
                onTouchEnd={handleTouchEnd}
                onMouseDown={handleMouseDown}
                onMouseUp={handleMouseUp}
            >
                <div
                    className="flex transition-transform duration-300"
                    style={{ transform: `translateX(-${activeIndex * 100}%)` }}
                >
                    {testimonials.map((item, index) => (
                        <div key={index} className="w-full min-w-full flex justify-center">
                            <div className={`flex flex-col p-6 gap-6 rounded-[12px] bg-${isPage ? "white" : "gray-50"} border-2 border-gray-100`}>
                                <Quote className="fill-gray-600 w-6 h-6" />
                                <div className="flex flex-col gap-3">
                                    <Typography size="20" weight="md">{item.text}</Typography>
                                    <Typography size="16" weight="rg">
                                        {item.author}<br />
                                        <Typography size="16" weight="rg" color="gray-600">@ {item.university}</Typography>
                                    </Typography>
                                </div>
                            </div>
                        </div>
                    ))}
                </div>

                {/* Paginazione */}
                <div className="flex justify-center gap-2 mt-4">
                    {testimonials.map((_, index) => (
                        <div
                            key={index}
                            className={`w-[6px] h-[6px] rounded-full transition-all ${index === activeIndex ? "bg-black" : "bg-gray-300"
                                }`}
                        />
                    ))}
                </div>
            </div>
        </div>
    );
}